import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_WARRANTIES_LIST = {
  'job': {},
  'part': {},
  'subcontractList': [],
  'loading': false,
};

export const warrantiesAdminCategories = (state, action) => {
  return createReducer(INITIAL_STATE_WARRANTIES_LIST, {
    [ActionTypes.FETCHING_TWC_WARRANTIES_ADMIN_JOB]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_JOB]: (state, action) => ({
      ...state,
      'loading': false,
      'job': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_JOB_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'job': {},
    }),
    [ActionTypes.FETCHING_TWC_WARRANTIES_ADMIN_SUBCONTRACT_LIST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_SUBCONTRACT_LIST]: (state, action) => ({
      ...state,
      'loading': false,
      'subcontractList': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_SUBCONTRACT_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'subcontractList': [],
    }),
    [ActionTypes.FETCHING_TWC_WARRANTIES_ADMIN_PART]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_PART]: (state, action) => ({
      ...state,
      'loading': false,
      'part': action.response.data,
    }),
    [ActionTypes.FETCHED_TWC_WARRANTIES_ADMIN_PART_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'part': {},
    }),
    [ActionTypes.CLEAR_SEARCH_PART_WARRANTY_ADMIN]: (state, action) => ({
      ...state,
      'loading': false,
      'part': {},
    }),
  })(state, action);
};

